import { render } from "./Srock.vue?vue&type=template&id=d0fb482e"
import script from "./Srock.vue?vue&type=script&lang=js"
export * from "./Srock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__